import {Component} from '@angular/core';
import {InfoBannerType, LoginPageLang, UtilsService} from '../../../shared';
import {TranslateService} from '@ngx-translate/core';
import {ActivatedRoute} from '@angular/router';
import {interval} from 'rxjs';
import {take, takeWhile} from 'rxjs/operators';

@Component({
    selector: 'sl-login',
    templateUrl: './login.component.html'
})
export class LoginComponent extends LoginPageLang {
    public readonly redirectRoute: string = '/produkte/identifikation';

    public bannerType: InfoBannerType;
    public showBanner: boolean = false;
    public bannerTextKey: string;
    public showWelcomeTitle: boolean = false;

    constructor(private translateService: TranslateService,
                private utilsService: UtilsService,
                private route: ActivatedRoute) {
        super();
        this.getUrlParams();
    }

    public getUrlParams() {
        this.route.queryParamMap.pipe(take(1)).subscribe(params => {
            if (params) {
                let stopCondition = false;
                switch (params.get('emailConfirm')) {
                    case 'activated':
                        stopCondition = this.onActiveEmail(stopCondition);
                        this.showWelcomeTitle = true;
                        break;
                    case 'expired':
                        stopCondition = this.onExpiredEmail(stopCondition);
                        this.showWelcomeTitle = false;
                        break;
                }
            }
        });
    }

    private onExpiredEmail(stopCondition: boolean) {
        interval(0).pipe(takeWhile(() => !stopCondition)).subscribe(() => {
            stopCondition = true;
            this.makeBannerMessage(InfoBannerType.DANGER, 'LOGIN.emailConfirmExpired');
        });
        return stopCondition;
    }

    private onActiveEmail(stopCondition: boolean) {
        interval(0).pipe(takeWhile(() => !stopCondition)).subscribe(() => {
            stopCondition = true;
            this.makeBannerMessage(InfoBannerType.SUCCESS, 'REGISTRATION.success');
        });
        return stopCondition;
    }

    private makeBannerMessage(type: InfoBannerType, lang: string) {
        this.setBannerState(type);
        this.bannerTextKey = lang;
    }

    private setBannerState(type: InfoBannerType): void {
        this.bannerType = type;
        this.showBanner = true;
    }

}
